import { createContext } from 'react';

export const FormDataContext = createContext({
    formContext: {},
    setFormContext: (formContext: any) => { },
});

